<template>
  <div id="app">
    <van-row>
      <van-col span="24" :class="is_mobile ? 'download_mobile' : 'download_pc' " :style='{backgroundImage: is_mobile ? "url(" + download.app_bg_img + ")" : "url(" + download.bg_img + ")"}'>
        <van-col span="12" offset="6">
          <van-col span="24" class="download_pc_img">
            <van-image width="100" height="100" :src="download.img" />
          </van-col>
          <van-col span="24" class="download_pc_title">{{ download.title }}</van-col>
          <van-col span="24" class="download_pc_center">{{ download.center }}</van-col>
          <van-col span="24" class="download_code" v-show="invite_code">{{ $t('column.Invitation_code') }}: {{ invite_code }}</van-col>
          <van-col span="24" v-if="is_mobile">
            <van-col span="24" class="download_mobile_url" @click="download_btn(0)"> {{ $t('btn.download_now')}} </van-col>
          </van-col>
          <van-col span="24" class="download_pc_wid" v-else>
            <van-col span="12">
              <van-col span="20" class="download_pc_android_url" @click="download_btn(1)"> {{ $t('btn.android_download')}}</van-col>
              <van-col span="20" class="download_pc_ios_url" @click="download_btn(2)"> {{ $t('btn.ios_download')}} </van-col>
            </van-col>
            <van-col span="12" class="download_pc_code">
              <div class="qrcode" ref="qrCodeUrl" style="padding:10px;border-radius: 10px;"></div>
            </van-col>
          </van-col>
        </van-col>
      </van-col>
    </van-row>
    <div id='weixin-tip-box' v-if="is_weixin">
      <div class="triangle_border_up">
        <span></span>
      </div>
      <div class="weixin-tip">
        <p> 请点击右上角</p>
        <p class="content"> 选择"浏览器中打开" </p>
      </div>
    </div>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import QRCode from 'qrcodejs2'
  export default {
    data() {
      return {
        download: {
          'bg_img': '',
          'app_bg_img':'',
          'img': '',
          'title': '',
          'center' : '',
          'ios': '',
          'Android': '',
          'u_link_id': '',
          'um_from_appkey': '',
          'invite_code': '',
        },
        is_mobile: false,
        is_weixin: false,
      }
    },
    created: function() {
      document.title = this.$t('title.download_title')
      this.invite_code= this.$route.query.invite_code
      this.isWeiXin()
      this.isMobile()
      this.convert()
    },
    mounted() {
      // 将要给原生调用的方法挂载到 window 上面
      window.mobile_intercept = this.mobile_intercept
      this.is_mobile = window.matchMedia("(max-width: 425px)").matches;
    },
    methods: {
      isWeiXin() {
        var ua = window.navigator.userAgent.toLowerCase();
        // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
        if (ua.indexOf('micromessenger') > -1) {
          this.is_weixin = true // 是微信端
        } else {
          this.is_weixin = false
        }
        console.log('is_weixin:' + this.is_weixin)
      },
      isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        this.is_mobile = flag ? true : false
      },
      creatQrCode() {
        new QRCode(this.$refs.qrCodeUrl, {
          text: window.location.href, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      download_btn(type) {
        let url = ''
        if(this.is_mobile){
          const u = navigator.userAgent, app = navigator.appVersion;
          const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          url = isiOS ? this.download.ios :  this.download.Android
        }else{
          // 下载
          url =type == 1 ? this.download.Android : this.download.ios
        }
        window.location.href = url
      },
      get_ULink() {
        const u_link_id = this.download.u_link_id
        const invite_code= this.$route.query.invite_code
        const um_from_appkey =  this.download.um_from_appkey
        ULink({
          id: u_link_id,
          data: { // 传递的自定义动态参数
            invite_code: invite_code,
            _sdk_: 'umeng',
            _linkid_: u_link_id,
            um_from_appkey: um_from_appkey,
            _bizType_: 'ushare'
          },
          selector: '#download_but',// 绑定唤端
          timeout: 2000,
          useOpenInBrowerTips: 'default',
          lazy: false,
          auto: false,
          useClipboard: true,
          proxyOpenDownload: function (defaultAction, ctx) {

            if (ctx.solution.type === 'scheme') {
              if (ULink.isWechat || ULink.isQQ) {
                defaultAction();
              } else {
                location.href = ctx.solution.downloadUrl
              }
            }
          }
        })
      },

      convert: function() {
        axios.post(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=get_download").then(res =>{
          this.download = res.data.data
          console.log(this.download)
          document.title = this.download.title + this.$t('title.download_title')
          if (this.is_mobile === true) {
            if (this.download.u_link_id) {
              this.get_ULink()
            }
          } else {
            this.creatQrCode()
          }
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/download.vue